import '../scss/about.scss';

import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import 'swiper/css'
import 'swiper/css/navigation';
import 'lightbox2'

import menuModule from "./modules/menu.js";
import scrollUpModule from "./modules/scrollUpModule.js";
import footerModule from "./modules/footerModule.js";

(function ($) {
    $(document).ready(function () {
        window.$ = jQuery;

        menuModule.init();
        scrollUpModule.init();
        footerModule.init();

        // ABOUT
        new Swiper('.about-swiper', {
            modules: [Navigation],
            slidesPerView: 3,
            spaceBetween: 30,
            navigation: {
                nextEl: '.button-next',
                prevEl: '.button-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                576: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                }
            }
        });
    });
}(jQuery));



